import clsx from 'clsx'
import { CharacterBadge } from 'Types/character'
import { useCharacterDisplayBadge } from '@/hooks/useCharacterBadgeConfig'
import { CharacterBadgeConfig } from '@/types/characterBadgeConfig'
import { ReactNode } from 'react'

type CharacterWinnerBadgeIconProps = {
  badges?: CharacterBadge[] | string[] | null
  className?: string
  width?: number
  height?: number
}

type CharacterWinnerBadgeGuardProps = {
  badges?: CharacterBadge[] | string[] | null
  children: (badge: CharacterBadgeConfig) => ReactNode
}

export function CharacterWinnerBadgeGuard({
  badges,
  children,
}: CharacterWinnerBadgeGuardProps) {
  const badge = useCharacterDisplayBadge(badges)

  if (!badge) return null

  return <>{children(badge)}</>
}

export default function CharacterWinnerBadgeIcon({
  badges,
  className,
  width,
  height,
}: CharacterWinnerBadgeIconProps) {
  const badge = useCharacterDisplayBadge(badges)

  if (!badge) return null

  return (
    <img
      src={badge.icon_value}
      alt={badge.display_name}
      title={badge.display_name}
      width={width}
      height={height}
      className={clsx('object-contain', className)}
    />
  )
}
